module.exports = __webpack_public_path__ + "img/icon-mobile.1c61e965.png";